import { api } from "./_client";

export async function listCreditPacks() {
    const { data } = await api.get("/credit-packs");
    return Array.isArray(data) ? data : [];
}

export async function claimCreditPack(packId) {
    const { data } = await api.post(`/me/credit-packs/${packId}/claim`);
    return data;
}

export async function redeemPromoCode(code) {
    const { data } = await api.post("/me/promo-codes/redeem", { code });
    return data; // { ok, effect, balance }
}

export const AI_PROVIDER_OPTIONS = [
    { id: "", label: "Use global default" },
    { id: "anthropic", label: "Anthropic Claude (direct)" },
    { id: "anthropic_emergent", label: "Anthropic Claude (Emergent key)" },
    { id: "openai", label: "OpenAI GPT" },
    { id: "gemini", label: "Google Gemini" },
    { id: "grok", label: "xAI Grok" },
];

export async function listSubscriptionTiers() {
    const { data } = await api.get("/subscription-tiers");
    return data.tiers || [];
}

export async function getMyCredits() {
    const { data } = await api.get("/me/credits");
    return data;
}

export async function getMySubscription() {
    const { data } = await api.get("/me/subscription");
    return data;
}

export async function refreshMySubscription() {
    const { data } = await api.post("/me/subscription/refresh");
    return data;
}
// -------- Admin user-subscription management --------

export async function getFeatureFlags() {
    const { data } = await api.get("/feature-flags");
    return data.flags || {};
}

export async function getRevenueCatPublicConfig() {
    const { data } = await api.get("/revenuecat/public-config");
    return data;
}
